import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-audit-trail-node',
  templateUrl: './app-audit-trail-node.component.html',
  styleUrls: ['./app-audit-trail-node.component.scss'],
})
export class AppAuditTrailNodeComponent {
  @Input() title: string = '';
  @Input() time: string = '';
  @Input() description: string = '';
  @Input() dotColor: string = 'slate';
  @Input() titleColor: string = 'default';
  @Input() isNote: boolean = false;
  @Input() customClass: string = '';
  @Input() isLast: boolean = false;

  getDotClass(): string {
    const color = (this.dotColor || 'slate').toLowerCase();
    if (color.startsWith('node-dot-')) {
      return color;
    }
    if (color === 'indigo' || color === 'blue') return 'node-dot-indigo';
    if (color === 'emerald' || color === 'green') return 'node-dot-emerald';
    if (color === 'rose' || color === 'red') return 'node-dot-rose';
    if (color === 'dark') return 'node-dot-dark';
    return 'node-dot-slate';
  }

  getTitleClass(): string {
    const color = (this.titleColor || 'default').toLowerCase();
    if (color.startsWith('node-title-')) {
      return color;
    }
    if (color === 'rose' || color === 'red') return 'node-title-rose';
    if (color === 'emerald' || color === 'green') return 'node-title-emerald';
    return 'node-title';
  }
}
